import { IReductionCardFTO } from '../../api/Ticketshop';
import reductionCardsApi from './nj-reduction-cards.json';

export class ReductionCardsApi {

    private static cardsByCode: Map<number, IReductionCardFTO>;

    static getData() {
        return reductionCardsApi;
    }

    static getCards(): IReductionCardFTO[] {
        const cards: IReductionCardFTO[] = [];

        for (const o of reductionCardsApi) {
            if (o.reductionCards.isChallenged) {
                cards.push(o.reductionCards);
            }
        }

        return cards;
    }

    static getCardsChallenged(): IReductionCardFTO[] {
        const challenged: IReductionCardFTO[] = [];

        for (const o of reductionCardsApi) {
            if (o.reductionCards.isChallenged) {
                challenged.push(o.reductionCards);
            }
        }

        return challenged;
    }

    static getCardData(code: number): IReductionCardFTO | null {
        if (!this.cardsByCode) {
            this.cardsByCode = new Map(reductionCardsApi.map(card => [card.reductionCards.code, card.reductionCards]));
        }
        return this.cardsByCode.get(code);
    }
}
